import { EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';

/**
 * Показатели для графика: dataKey, подпись, ось Y, цвет. engineHours - ось X.
 * equivalentHours отдельной линией не рисуется: он показывается в скобках
 * под наработкой в подписи оси X (см. MeasurementAxisTick).
 */
export const ENGINE_MEASUREMENT_CHART_SERIES = [
  {
    dataKey: 'countOfStarts',
    name: 'Количество пусков',
    yAxisId: 'left',
    stroke: '#83a6ed',
    unit: '',
  },
  {
    dataKey: 'temperatureStatorU',
    name: 'Температура статора, фаза U',
    yAxisId: 'left',
    stroke: '#8dd1e1',
    unit: '°C',
  },
  {
    dataKey: 'temperatureStatorV',
    name: 'Температура статора, фаза V',
    yAxisId: 'left',
    stroke: '#5aa9bd',
    unit: '°C',
  },
  {
    dataKey: 'temperatureStatorW',
    name: 'Температура статора, фаза W',
    yAxisId: 'left',
    stroke: '#3d7f91',
    unit: '°C',
  },
  {
    dataKey: 'temperatureBrgDe',
    name: 'Температура подшипников DE',
    yAxisId: 'left',
    stroke: '#82ca9d',
    unit: '°C',
  },
  {
    dataKey: 'temperatureBrgNde',
    name: 'Температура подшипников NDE',
    yAxisId: 'left',
    stroke: '#a4de6c',
    unit: '°C',
  },
  {
    dataKey: 'temperatureAirH',
    name: 'Температура воздуха H',
    yAxisId: 'left',
    stroke: '#d0ed57',
    unit: '°C',
  },
  {
    dataKey: 'temperatureAirC',
    name: 'Температура воздуха C',
    yAxisId: 'left',
    stroke: '#ffc658',
    unit: '°C',
  },
  {
    dataKey: 'vibrationDe',
    name: 'Вибрация DE',
    yAxisId: 'right',
    stroke: '#ff7c7c',
    unit: 'мм/с',
  },
  {
    dataKey: 'vibrationNde',
    name: 'Вибрация NDE',
    yAxisId: 'right',
    stroke: '#ff8042',
    unit: 'мм/с',
  },
] as const;

export const ENGINE_MEASUREMENT_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'engineHours',
    label: 'Наработка машины (часы)',
    type: EFieldType.number,
    placeholder: 'Введите количество часов',
    required: true,
  },
  {
    name: 'equivalentHours',
    label: 'Эквивалентные часы (если известны)',
    type: EFieldType.number,
    placeholder: 'Экв. часы = Наработка + 20 * кол-во запусков',
  },
  {
    name: 'countOfStarts',
    label: 'Количество запусков',
    type: EFieldType.number,
    placeholder: 'Введите количество запусков',
  },
  {
    name: 'temperatureStatorU',
    label: 'Температура статора, фаза U',
    type: EFieldType.number,
    placeholder: 'Введите температуру фазы U',
  },
  {
    name: 'temperatureStatorV',
    label: 'Температура статора, фаза V',
    type: EFieldType.number,
    placeholder: 'Введите температуру фазы V',
  },
  {
    name: 'temperatureStatorW',
    label: 'Температура статора, фаза W',
    type: EFieldType.number,
    placeholder: 'Введите температуру фазы W',
  },
  {
    name: 'temperatureBrgDe',
    label: 'Температура приводного подшипника DE',
    type: EFieldType.number,
    placeholder: 'Введите температуру подшипника DE',
  },
  {
    name: 'temperatureBrgNde',
    label: 'Температура неприводного подшипника NDE',
    type: EFieldType.number,
    placeholder: 'Введите температуру подшипника NDE',
  },
  {
    name: 'temperatureAirH',
    label: 'Температура горячего воздуха (если известна)',
    type: EFieldType.number,
    placeholder: 'Введите температуру воздуха H',
  },
  {
    name: 'temperatureAirC',
    label: 'Температура холодного воздуха (если известна)',
    type: EFieldType.number,
    placeholder: 'Введите температуру воздуха C',
  },
  {
    name: 'vibrationDe',
    label: 'Виброскорость приводного подшипника DE',
    type: EFieldType.number,
    placeholder: 'Введите вибрацию DE',
  },
  {
    name: 'vibrationNde',
    label: 'Виброскорость неприводного подшипника NDE',
    type: EFieldType.number,
    placeholder: 'Введите вибрацию NDE',
  },
];
